import { useNavigate, useLocation } from "react-router-dom";
import { t, getLang } from "../../lang";
import {useEffect, useState} from "react";
const itemData = [
    {
        name : "menu.new_game",
        icon : <img src="/img/icons/Frame.svg" alt="gift" />,
        link : '/newgame'
    },
    {
        name : "menu.favorite_game",
        icon : <img src="/img/icons/favorite.svg" alt="favorite" />,
        link : '/favorite'
    },
    {
        name : "menu.slot",
        icon : <img src="/img/icons/octicon_goal-24.svg" alt="gift" />,
        link : '/slot'
    },
    {
        name : "menu.live",
        icon : <img src="/img/icons/live.svg" alt="live" />,
        link : '/live'
    },
] ;

export default function LandingNavBar(){
    const navigate = useNavigate() ;
    const location = useLocation() ;
    const [lang, setLangState] = useState(getLang());

    useEffect(() => {
        const handler = () => setLangState(getLang());
        window.addEventListener("langChanged", handler);
        return () => window.removeEventListener("langChanged", handler);
    }, []);

    const navigatePage = ( link ) => e => {
        navigate( link, { replace : true } ) ;
    }
    return(
        <>
            <div className='landing-nav-mobile'>
                {
                    itemData.map( ( item, index ) => (
                        <div 
                            className={`landing-nav-mobile-item ${location.pathname === item.link ? 'active' : ''}`} 
                            key={ index } 
                            onClick={ navigatePage( item.link ) }
                        >
                            { item.icon }
                            <span>{ t(item.name) }</span>
                        </div>
                    ) )
                }
            </div>
        </>
    )
}